export const config = {
    type: 'GROUP_TEXT',
    title: '段落文本',
    defaultProps: {
        title: '标题',
        content: '这里是一些介绍',
        titleStyle: {
            color: '#000',
            backgroundColor: "transparent",
            fontSize: '20px',
            textAlign: 'left',
        },
        contentStyle: {
            color: '#434343',
            backgroundColor: "transparent",
            fontSize: '16px',
            textHeight: '1.5',
        },
        style: {
            backgroundColor: "transparent",
            borderRadius: "0px",
            marginBottom: "0px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop: "0px",
            minHeight: "100px",
            padding: "15px",
        }
    },
    preview: {
        style: {
            padding: '8px'
        },
        items: [
            {
                style: {
                    width: '30%',
                    height: '16px',
                    background: 'var(--semi-color-fill-2)',
                    marginBottom: '8px'
                }
            },
            {
                style: {
                    width: '90%',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)',
                    marginBottom: '6px'
                }
            },
            {
                style: {
                    width: '80%',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)'
                }
            }
        ]
    }
};